import { render } from "./App.vue?vue&type=template&id=4a8fbd50&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4a8fbd50&lang=scss&scoped=true"

import exportComponent from "/srv/cometo/aos_anmeldung/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a8fbd50"]])

export default __exports__